import $ from "jquery";

$(document).on("turbo:load", () => {
  $('.transaction-description a.expandable').on("click", (e) => {
    e.preventDefault();
    $(e.target).closest('div').children('.transaction-expand').slideToggle()
  });
});
